<template>
  <div>
     <!-- <div class="card-panel hoverable">
      <h5> <b style="color: red">Notice!</b> </h5>
      <p> <b>Dear esteemed customer, Please be informed that electricity tariffs for all DISCOs have been revised, 
        Kindly <router-link to="/power/tariffs">click here</router-link> to see the updated tariffs applicable to you effective 1st November 2020 </b> </p>
    </div> -->
    <div class="row" v-if="signedSession">
      <div
        class="col s12 m12 l6 animated zoomInLeft"
        id="leftContainment"
        :class="[
          windows.width >= 1200 ? 'l6' : 'l6',
          windows.width >= 600 && windows.width <= 900 ? 'm12' : 'm6'
        ]"
        :style="[
          windows.width >= 1200 ? 'display: block' : 'display: block',
          windows.width >= 600 && windows.width <= 910
            ? 'display: none'
            : 'display: block'
        ]"
      >
        <div class="card-panel hoverable" :class="{ blur: proccedBtn }">
          <h5>Electricity</h5>
          <form @submit.prevent="getMeterInfo" id="form">
            <div class="row">
              <div class="col s12 m6">
                <label>Select State</label>
                <select
                  v-model="fields.state"
                  class="browser-default"
                  @change="getDisco(fields.state, fields.meterType, lagosDisco)"
                  id="state"
                >
                  <option value="" disabled selected>Select option</option>
                  <option
                    v-for="(state, index) in states"
                    :key="index"
                    :value="state"
                    >{{ state }}</option
                  >
                </select>
              </div>
              <div class="col s12 m6">
                <label>Select Meter Type</label>
                <select
                  v-model="fields.meterType"
                  class="browser-default"
                  @change="getDisco(fields.state, fields.meterType, lagosDisco)"
                  id="meterType"
                >
                  <option value="" disabled selected>Select option</option>
                  <option :value="1">Prepaid</option>
                  <option :value="2">Postpaid</option>
                </select>
              </div>
            </div>
            <div class="row" v-show="fields.state == 'Lagos'">
              <div class="input-field col s12 m12">
                <select
                  v-model="lagosDisco"
                  @change="getDisco(fields.state, fields.meterType, lagosDisco)"
                >
                  <option value="" disabled selected>Select option</option>
                  <option :value="1">Eko Distribution Company</option>
                  <option :value="2">Ikeja Distribution Company</option>
                </select>
                <label>Select Disco</label>
              </div>
            </div>
            <div class="row">
              <div class="input-field col s12 m6">
                <input
                  id="meter_number"
                  type="text"
                  v-model="fields.receiver"
                />
                <label for="meter_number">Meter Number</label>
              </div>
              <div class="input-field col s12 m6">
                <input
                  id="amount"
                  type="text"
                  v-model="fields.amount"
                  @change="formatNumber(fields.amount)"
                />
                <label for="amount">Amount</label>
              </div>
            </div>
            <div class="row">
              <div class="input-field col s12 m6">
                <input id="email" type="email" v-model="fields.email" />
                <label for="email">Email Address</label>
              </div>
              <div class="input-field col s12 m6">
                <input id="phone" type="text" v-model="fields.phone" />
                <label for="phone" class="active">Phone Numbers</label>
              </div>
            </div>
            <div class="row">
              <div v-if="loading">
                <img src="ui/img/loading.svg" alt="Time Loader" />
                <p><i>Loading...</i></p>
              </div>
              <div class="col s12 m12" v-else>
                <button
                  class="waves-effect waves-light btn-small"
                  type="submit"
                  :disabled="proccedBtn"
                >
                  <i class="material-icons right">send</i>
                  Submit
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div
        class="col s12 m12 l6"
        id="rightContainment"
        :class="[
          windows.width >= 1200 ? 'l6' : 'l6',
          windows.width >= 600 && windows.width <= 900 ? 'm12' : 'm6'
        ]"
      >
        <transition name="slide-fade">
          <div v-if="showSummary" class="card-panel z-depth-3">
            <h5>Transaction Summary</h5>
            <table class="highlight">
              <tbody>
                <tr>
                  <th>Meter Disco</th>
                  <td>{{ discoName }}</td>
                </tr>
                <tr>
                  <th>Meter Name</th>
                  <td>{{ custName }}</td>
                </tr>
                <tr>
                  <th>Meter Number</th>
                  <td>{{ fields.receiver }}</td>
                </tr>
                <tr>
                  <th>Amount</th>
                  <td>&#8358; {{ totalAmount }}</td>
                </tr>
                <tr>
                  <th>Phone Number</th>
                  <td>{{ fields.phone }}</td>
                </tr>
                <tr>
                  <th>Email Address</th>
                  <td>{{ fields.email }}</td>
                </tr>
                <tr>
                  <th>Payment method</th>
                  <td>
                    <select
                      class="browser-default"
                      id="payoption"
                      v-model="payment_option"
                    >
                      <option value="" disabled selected
                        >Choose your option</option
                      >
                      <option value="1">Pay with Card</option>
                      <option value="2">Pay with Voucher</option>
                      <option value="3">Pay with USSD</option>
                      <option value="4">Pay with Bank Transfer</option>
                      <option value="5">Pay with Wallet</option>
                    </select>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="row" v-show="proccedBtn">
              <div class="col s12 m12" style="margin-top: 15px">
                <div v-if="vending">
                  <img src="ui/img/loading.svg" alt="Time Loader" />
                  <p><i>Loading...</i></p>
                </div>
                <div v-else>
                  <div class="right">
                    <a
                      class="waves-effect waves-light btn-small"
                      @click="payOption(payment_option)"
                      >Pay</a
                    >
                  </div>
                  <a
                    class="waves-effect waves-light btn-small left"
                    @click="revert"
                    >Back</a
                  >
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
      <!-- Customer Info Modal Structure -->
      <div id="customerInfo" class="modal services">
        <div class="modal-content">
          <h4>{{ custName }}</h4>
          <p class="text-left">
            <strong>Disco:</strong> {{ discoName }}<br />
            <strong>Meter number:</strong> {{ fields.receiver }}<br />
            <strong>Meter Address:</strong> {{ custAddress }}<br />
            <strong>Amount:</strong> &#8358; {{ totalAmount }}
            <span v-if="fields.meterType != 2"
              >(&#8358; 100 convenience fee inclusive)</span
            >
            <br />
            <!-- <strong>Estimated Units:</strong> {{ estUnits }} -->
          </p>
        </div>
        <div class="modal-footer">
          <a
            class="modal-close waves-effect waves-green btn-flat"
            style="margin-right: 10px"
            @click="verifiedMeter"
            >Confirm</a
          >
          <a
            class="modal-close waves-effect waves-green btn-flat"
            @click="revert"
            >Go Back</a
          >
        </div>
      </div>
      <!-- Customer Info Modal Structure -->
      <!-- Voucher Modal Structure -->
      <div id="voucher" class="modal services">
        <div class="modal-header">
          <a class="modal-close waves-effect btn-small waves-green right">x</a>
          <img src="ui/img/logo.png" width="18%" class="responsive-img" />
        </div>
        <div class="modal-content">
          <form>
            <h5>Enter Voucher Code</h5>
            <div class="row">
              <div class="input-field col s12 m8 offset-s2 offset-m2">
                <input
                  placeholder="Voucher Code"
                  id="voucher_code"
                  type="text"
                  v-model="voucher_code"
                />
              </div>
            </div>
            <div class="row" v-if="vouching">
              <div class="col s4 offset-s4 m4 offset-m4">
                <img src="ui/img/loading.svg" alt="Time Loader" />
                <p><i>Loading...</i></p>
              </div>
            </div>
            <div class="row" v-else>
              <a
                class="waves-effect waves-light btn-small"
                type="submit"
                @click="verifyVoucher"
                >Redeem Voucher</a
              >
            </div>
          </form>
        </div>
      </div>
      <!-- Voucher Modal Structure -->
      <ussd-code
        :transactionID="transactionID"
        :coralCode="coralpayCode"
        :service="service"
        @ussd-complete="ussdComplete"
      />
      <bank-transfer
        :transactionID="transactionID"
        :amount="totalAmount"
        :details="generateDetails"
        :service="service"
        @ussd-complete="ussdComplete"
      />
      <!-- Vending Status Modal Structure -->
      <div id="vendStatus" class="modal services">
        <div class="modal-header">
          <a class="modal-close waves-effect btn-small waves-green right">x</a>
        </div>
        <div class="modal-content">
          <div class="feedbackForm" v-if="!feedback">
            <div v-if="successModal">
              <img
                src="ui/img/success.png"
                width="12%"
                class="responsive-img"
              />
              <h6>Your order has been completed sucessfully.</h6>
            </div>
            <div v-if="!successModal">
              <img src="ui/img/failed.png" width="12%" class="responsive-img" />
              <h6>Order was not sucessful.</h6>
            </div>
            <div class="row">
              <div class="col s12 m6">
                <h6><strong>Transaction Details</strong></h6>
                <p><strong>Transaction Ref:</strong> {{ transactionID }}</p>
                <div v-if="fields.meterType == '1'">
                  <p>
                    <strong>
                      Token:<br />
                      <span class="token">{{ token }}</span>
                      <button
                        type="button"
                        @click="doCopy"
                        class="copyBtn btn-small"
                        style="padding: 1px 7px; font-size: 11px;"
                      >
                        Click to copy
                      </button>
                    </strong>
                  </p>
                  <p><strong>Units:</strong> {{ units }}</p>
                </div>
              </div>
              <div class="col s12 m6">
                <h6><strong>Customer Details</strong></h6>
                <p><strong>Order Info:</strong> {{ orderInfo }}</p>
                <p>
                  <strong>Email:</strong>
                  {{ fields.email == '' ? 'Not provided' : fields.email }}
                </p>
                <p><strong>Phone</strong> {{ fields.phone }}</p>
              </div>
            </div>
            <hr style="width: 65%" />
            <div v-show="!feedbackSuccess && successModal">
              <div class="row">
                <div class="col s12 m6 l6">
                  <h6><strong>How was your experience?</strong></h6>
                  <a
                    href="#"
                    @click.prevent="
                      feedback = true
                      feedbackfield.satisfaction = true
                      feedbackfield.recommend = true
                    "
                  >
                    <img
                      class="feedbackEmoji"
                      src="ui/img/happyface.png"
                      style="margin-right: 10px"
                    />
                  </a>
                  <a
                    href="#"
                    @click.prevent="
                      feedback = true
                      feedbackfield.satisfaction = false
                      feedbackfield.recommend = false
                    "
                  >
                    <img class="feedbackEmoji" src="ui/img/sadface.png" />
                  </a>
                </div>
                <div class="col s12 m6 l6">
                  <h6><strong>Share with a friend</strong></h6>
                  <i
                    @click="whatsApp"
                    class="fa fa-whatsapp"
                    style="font-size: 37px; cursor: pointer; color: #008000; margin-right: 15px"
                  ></i>
                  <!-- <i @click="whatsApp" class="fa fa-facebook" style="font-size: 37px; cursor: pointer; color: #0b0b77"></i> -->
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="row" style="clear: both; padding: 15px 0px 10px">
            <button class="btn-small" @click="createAccount('signup')">Create Account</button>
          </div> -->
          <div class="feedbackForm" v-if="feedback">
            <h5 style="margin-bottom: 40px">Customer feedback form</h5>
            <form @submit.prevent="sendFeedback">
              <div class="row">
                <div class="col s6 m6">
                  <div class="switch">
                    <strong>Are you satisfied with the service:</strong> <br />
                    <label>
                      No
                      <input
                        type="checkbox"
                        v-model="feedbackfield.satisfaction"
                      />
                      <span class="lever"></span>
                      Yes
                    </label>
                  </div>
                </div>
                <div class="col s6 m6">
                  <div class="switch">
                    <strong>Would you recommend irecharge to a friend: </strong
                    ><br />
                    <label>
                      No
                      <input
                        type="checkbox"
                        v-model="feedbackfield.recommend"
                      />
                      <span class="lever"></span>
                      Yes
                    </label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="input-field col s12 m10 offset-m1">
                  <textarea
                    class="materialize-textarea comment"
                    data-length="120"
                    maxlength="120"
                    v-model="feedbackfield.comment"
                  ></textarea>
                  <label for="textarea2">Comment</label>
                </div>
              </div>
              <div class="row" v-if="feedbackloading">
                <div class="col s4 offset-s3 m4 offset-m3">
                  <img src="ui/img/loading.svg" alt="Time Loader" />
                  <p><i>Loading...</i></p>
                </div>
              </div>
              <div class="row" style="margin-bottom: 50px" v-else>
                <a
                  class="waves-effect waves-light btn-small"
                  type="submit"
                  @click="feedback = false"
                  style="margin-right: 10px"
                  >No Thanks</a
                >
                <a
                  class="waves-effect waves-light btn-small"
                  type="submit"
                  @click="sendFeedback"
                  >Send Feedback</a
                >
              </div>
            </form>
          </div>
          <p style="clear:both">
            <img src="ui/img/thanks.png" width="21%" class="responsive-img" />
          </p>
        </div>
      </div>
      <!-- Vending Status Modal Structure -->
      <!-- Wallet Modal Structure -->
      <div id="wallet" class="modal services">
        <div class="modal-header">
          <a class="modal-close waves-effect btn-small waves-green right">x</a>
        </div>
        <div class="modal-content">
          <form>
            <h5 style="margin: 30px">Verify Wallet Debit</h5>
            <div class="row">
              <div class="input-field col s12 m8 offset-s2 offset-m2">
                <input
                  id="wallet_username"
                  type="text"
                  v-model="wallet_username"
                />
                <label for="email_phone" class="active"
                  >Email/Phone number</label
                >
              </div>
              <div
                class="input-field col s12 m8 offset-s2 offset-m2"
                v-if="reveal == true"
              >
                <i
                  class="material-icons prefix"
                  @click="visibility"
                  style="cursor: pointer;"
                  >visibility_off</i
                >
                <input id="pass" type="text" v-model="wallet_password" />
                <label for="pass" class="active">Password</label>
              </div>
              <div
                class="input-field col s12 m8 offset-s2 offset-m2"
                v-if="reveal == false"
              >
                <i
                  class="material-icons prefix"
                  @click="visibility"
                  style="cursor: pointer;"
                  >visibility</i
                >
                <input
                  id="password"
                  type="password"
                  v-model="wallet_password"
                />
                <label for="password" class="active">Password</label>
              </div>
            </div>
            <div class="row" v-if="walletProcess">
              <div class="col s4 offset-s4 m4 offset-m4">
                <img src="ui/img/loading.svg" alt="Time Loader" />
                <p><i>Loading...</i></p>
              </div>
            </div>
            <div class="row" v-else>
              <a
                class="waves-effect waves-light btn-small"
                type="submit"
                @click="verifyWallet"
                >Validate</a
              >
            </div>
          </form>
        </div>
      </div>
      <!-- Wallet Modal Structure -->
      <create-account :attempt="updateAttempt" />
      <!-- Card details Modal Structure Number 8-->
      <card-response
        @otherCard="proceedWithNewCard"
        :cardDetails="retrieveCard"
        :loading="vending"
        @chargeCard="chargeCard"
      />
      <!-- Save Card details Modal Structure Number 9-->
      <save-card @saveCard="saveCard" />
    </div>
    <div v-else>
      <welcome @modal-option="selectedView" />
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import BankTransfer from '@/components/modals/BankTransfer.vue'
import UssdCode from '@/components/modals/UssdCode.vue'
import Welcome from '@/components/partials/Welcome.vue'
import CreateAccount from '@/components/modals/CreateAccount.vue'
import CardResponse from '@/components/modals/CardResponse.vue'
import SaveCard from '@/components/modals/SaveCard.vue'
export default {
  name: 'power',
  metaInfo: {
    // all titles will be injected into this template
    titleTemplate: '%s | Buy Electricity Online Instantly',
    meta: [
      {
        name: 'description',
        content:
          'iRecharge.com.ng Make bills payment for AEDC Abuja Electricity PHCN Bills for Prepaid and Postpaid meters online, Pay using your ATM/Debit card, AEDC'
      },
      {
        name: 'keywords',
        content:
          "phcn bill online, prepaid meter, pay electricity bill online, phcn online payment, phcn online bill payment, buy electricity with ATM, aedc, aedc recharge, recharge PHCN meter, kedco, NEPA meter recharge, kaduna electricity payment, prepaid meter tokens, pay bills, purchase electricity, buy meter token, buy data, buy power, buypower aedc, Jos Electricity Online, Kaduna Electric Online, KEDC Prepaid, KEDC Postpaid, recharge meter online, Buy electricity online, Pay electricity bills Easy, Effortless and Simple, buy power aedc, Nepa PHCN units online, buypower Nigeria, buypower Abuja, iRecharge Abuja, buy power ng, iRecharge ng, Pay as you go electricity, Recharge Electricity Abuja, Recharge Electricity Nigeria, Purchase electricity, Buypower in Nigeria, purchase light online, gtbank internet banking login, gtnank, internet banking gtb Nigeria, ibuypower discount code 2019, buy here pay here nepa, www.gtbank.com login, ibuypower office locations, buypower card application status, buypower customer service number, wow customers service, gtbank online account opening, electricals bill, paylightbill, paypower customer service, buy light online, online prepaid electricity, adec tech support, ibuypower customer support, gtbank com, buypower credit card login, electricity units, recharge.com customer service phone number, internet banking for gtbank, light recharge, ibuypower 2019, uba online banking, ibuypower tech support number, ikeja electric, buy electricity online, gtbank internet banking, wow 24 hour support number, uba bank mobile, ibuypower support, wow customer service number, gtbank internet banking nigeria, electricity bill app, buy power, buypowercard login, paga login, buy power login, buypower in abuja, buy power nigeria, buy electricity online, buy electricity meter online, buy prepaid electricity online, how buy electricity online, buy electricity online south africa, how to purchase electricity online, can you buy prepaid electricity online, buy electricity online in nigeria, prepaid electricity meter online recharge kolkata, can you buy electricity online, buy electricity online in south africa, buy electricity online eskom, how to buy electricity online in abuja, buy electricity online absa, buy electricity online abuja, buy electricity online aedc, buy electricity online cape town, buy electricity online capitec, buy electricity online cashpower, buy electricity online city of cape town, buy electricity online credit card, buy electricity online fnb, buy electricity online in abuja, buy electricity online in cape town, buy electricity online johannesburg, buy electricity online mossel bay, buy electricity online nedbank, buy electricity online nigeria, buy electricity online overstrand, buy electricity online port elizabeth, buy electricity online rwanda, buy electricity online standard bank, buy electricity online uk, buy electricity online with credit card, buy prepaid electricity online with credit card, buy unipin electricity online, buy zesa prepaid electricity online, how do i buy electricity online, how do you buy electricity online, how to buy electricity online capitechow to buy electricity online in nigeria, how to buy electricity online standard bank, prepaid electricity meter online recharge, prepaid electricity online south africa, register to buy electricity online, to buy electricity online, where can i buy electricity online, where can i buy prepaid electricity online, where to buy electricity online, where to buy prepaid electricity online, buy electricity fnb online banking, buy electricity meter online pakistan, buy electricity online airtricity, buy electricity online app, buy electricity online bali, buy electricity online botswana, buy electricity online botswana barclays, buy electricity online british gas, buy electricity online brunei, buy electricity online budget energy, buy electricity online capitec bank, buy electricity online city power, buy electricity online conlog, buy electricity online ekurhuleni, buy electricity online electric ireland, buy electricity online emfuleni municipality, buy electricity online george, buy electricity online hermanus, buy electricity online ibadan, buy electricity online in lagos, buy electricity online india, buy electricity online investec, buy electricity online itron, buy electricity online kaduna, buy electricity online kano, buy electricity online knysna, buy electricity online lagos, buy electricity online middelburg, buy electricity online namibia, buy electricity online nelson mandela bay, buy electricity online pick n pay, buy electricity online port harcourt, buy electricity online power ni, buy electricity online saldanha bay, buy electricity online sassa, buy electricity online sms, buy electricity online sse, buy electricity online stellenbosch, buy electricity online steve tshwete, buy electricity online via standard bank, buy electricity online vodacom, buy electricity online with absa, buy electricity online with capitec bank, buy electricity online with debit card, buy electricity online with sassa, buy electricity online with standard bank, buy electricity online zambia, buy electricity online zimbabwe, buy electricity tokens online, buy electricity top up online, buy electricity units online, buy electricity units online nigeria, buy electricity voucher online, buy prepaid electricity online cape town, buy prepaid electricity online durban, buy prepaid electricity online fnb, buy prepaid electricity online mossel bay, buy prepaid electricity online nedbank, buy tshwane electricity online, buy unipin prepaid electricity online, buying prepaid electricity online ghana, can i buy electricity online from absa, can i buy electricity online from fnb, can i buy electricity online from nedbank, can i buy electricity online from standard bank, can you buy electricity online with nedbank, can't buy electricity online, how to buy electricity online absa, how to buy electricity online brunei, how to buy electricity online fnb, how to buy electricity online from standard bank, how to buy electricity online in ghana, how to buy electricity online nedbank, how to buy electricity online using capitec, how to buy electricity online using fnb, how to buy electricity online using nedbank, how to buy electricity online using standard bank, how to buy electricity online with capitec, how to buy electricity online with fnb, how to buy electricity online with nedbank, prepaid electricity meter online recharge assam, prepaid electricity meter online recharge maharashtra, prepaid electricity online capitec, prepaid electricity online fnb, prepaid electricity online knysna, prepaid electricity online nedbank, prepaid electricity online recharge, prepaid electricity online standard bank, prepaid electricity vouchers online, purchase electricity online absa, purchase electricity online cape town, purchase electricity online nedbank, ways to buy electricity online, where can i buy electricity online capitec, why can't i buy electricity online, za buy electricity online, prepaid electricity meter online recharge pune"
      },
      {
        name: 'keywords',
        content:
          "kedco prepaid, powershop phone number, how to borrow unit from kedco, powershop, power shop contact number, buypower ng, buy power nigeria, www kedco ng, buypower abuja, how to buy and sell electricity, how to sell electricity online, buying and selling electricity, types of prepaid meters in Nigeria, prepaid meters nigeria, buy power nigeria, prepaid electricity meter in nigeria, prepaid meter nairaland, types of prepaid meters in nigeria, how to get prepaid meter in lagos nairaland, instant electricity, electricity tariff in nigeria, buypower jos, how to get a prepaid meter in lagos, irecharge nigeria, cost of electricity per kwh in nigeria 2017, buypower abuja, prepaid meter electricity, prepaid meter for sale in lagos, how to buy electricity online, advantages and disadvantages of prepaid electricity, electricity billing system in nigeria, how much is a unit of electricity in nigeria, prepaid energy meter advantages, electricity bill in nigeria, how to buy electricity, ng electric, ikeja electric prepaid meter token, cost of electricity in nigeria, how to use prepaid electricity meter, metering in nigeria, abuja electricity distribution company, download kano app, disadvantages of prepaid electricity system, buy online electricity, electricity credit token where to buy, buy electricity meter online, buy power nigeria, buypower nigeria, buy power bank in nigeria, buy power bike in nigeria, buy power online in nigeria, buy power online nigeria, power purchase agreement nigeria, buy electricity online, where to buy electricity, buy static electricity generator, buy electricity meter online, buy electricity in ph, where to buy electricity online, buy green electricity, how much prepaid electricity to buy, buy electricity from wholesale market, where to buy electricity near me, how buy electricity online, how to purchase electricity online, who can i buy electricity from, buy back electricity rates, buy electricity online in nigeria, electricity buy back rates, can you buy electricity online, buy electricity in abuja, places to buy electricity, electricity buy back, buy electricity abuja, buy electricity app, buy electricity at pick n pay, buy electricity bill online, buy electricity monitor, buy electricity near me buy electricity online abj, buy electricity online abuja, buy electricity online aedc, buy electricity online cape town, buy electricity online fbn, buy electricity online kaduna, buy your electricity, can i buy electricity with ucount rewards, can't buy electricity, can't buy electricity fnb, can't buy prepaid electricity, electricity buy back rates naija places to buy electricity near me, to buy electricity online, when to buy electricity, when to buy prepaid electricity, why can't i buy electricity, why can't i buy prepaid electricity, buy airtime or electricity, buy ekhwesi electricity, buy eko electricity online, buy ekurhuleni electricity online, buy electricity absa, buy electricity absa online, buy electricity aedc, buy electricity airtricity, buy electricity at atm, buy electricity at checkers, buy electricity at spar, buy electricity 2020, buy electricity bills, buy electricity lagos, buy electricity bulb, buy electricity by sms, buy electricity cables, buy electricity whatsapp, buy electricity easy pay, buy electricity english, buy electricity flow, buy electricity fnb, buy electricity fnb atm, buy electricity fnb online banking, buy electricity in lagos, buy electricity in nigeria, buy electricity in port harcourt, buy electricity internet banking, buy electricity jed, buy electricity kaduna, buy electricity kano, buy electricity kedco, buy electricity key, buy electricity kwh, buy electricity lamp, buy electricity light bulbs, buy electricity meter box, buy electricity meter key, buy electricity meter online nigeria, buy electricity mtn, buy electricity multimeter, buy electricity ni, buy electricity nigeria, buy electricity nuclear, buy electricity nus, buy electricity on jumia, buy power online jos, buy electricity online kaduna, buy electricity online kano, buy electricity online knysna, buy electricity online lagos, buy electricity online port harcourt, buy electricity online with debit card, buy electricity online jos, buy electricity online zimbabwe, buy electricity phed, buy electricity phone, buy electricity pick n pay, buy electricity power, buy electricity prices, buy electricity rates, buy electricity saving device, buy electricity smart meter, buy electricity unit online, buy electricity units, buy electricity units online nigeria, buy electricity using gtbank, buy electricity using airtime, buy electricity using uba, buy electricity using phone, buy electricity using atm card, buy electricity using standard bank, buy electricity via text, buy electricity via whatsapp chat, buy electricity via mtn, buy electricity via voice, buy electricity via sms, buy electricity via standard bank, buy electricity via vodacom, buy electricity mtn, buy electricity voucher online, buy electricity vouchers, buy electricity without meter number, buy electricity.com, buy electricity.ng, buy eskom electricity online absa, buy free electricity, buy natural electricity, buy ni electricity online, buy now pay later electricity, buy prepaid electricity imisi, buy prepaid electricity kogi, buy prepaid electricity online kano, buy prepaid electricity online bauchi, buy prepayment electricity meter, buy property electricity, buy renewable electricity, buy retail electricity, can i buy electricity directly from aedc, can't buy electricity phcn, can't buy electricity nepa, can't buy electricity online, can't buy electricity standard bank, can't buy electricity standard bank app, electricity buy back rates, eko electric, eko electric prepaid, eko electric recruitment, eko electric recruitment 2018, eko electric recruitment 2018 nairaland, eko electric recruitment 2019, eko electric salary, eko electric salary nairaland, eko electric stoves, eko electric vacancy, eko electric vehicle, eko electric wall fires, eko electric works, eko electric-import export, eko electricity distribution company contact, eko electricity distribution company nairaland, eko electricity distribution company salary nairaland, eko electricity form, eko electricity prepaid recharge, eko electricity tariff, map.eko electric, quickteller eko electric, 1963 eko electric guitar, eko electric scooter bangalore, eko fires electric stove, jos electric, schneider electric jobs, jos electricity distribution plc, jos electricity distribution company, jos electricity company, jos electricity distribution company logo, jos electricity distribution company recruitment, kano electric, kano electricity distribution company, kano auto electric, kano electric company, kano electricity, kano electricity distribution company address, kano electricity distribution company online payment, kaduna electric, kaduna electricity distribution company, buypower kaduna electric, kaduna electric company, kaduna electric customer care, kaduna electric distribution company, kaduna electric prepaid online payment, kaduna electric recharge, kaduna electric.com, kaduna electricity distribution company address, www.kaduna electric.com, how to pay for kaduna electric online, how to pay kaduna electric bill online, kaduna electric (corporate head office) kaduna, kaduna electric address, kaduna electric app, kaduna electric begins 24-hour power supply, kaduna electric bill payment, kaduna electric board of directors, kaduna electric buy power, kaduna electric crm, kaduna electric customer care line, kaduna electric customer service, kaduna electric download, kaduna electric error 77, kaduna electric form 74, kaduna electric irecharge, kaduna electric jobs, kaduna electric kaduna, kaduna electric logo, kaduna electric management, kaduna electric map, kaduna electric meter application, kaduna electric meter reading, kaduna electric news, kaduna electric nigeria, kaduna electric online payment, kaduna electric payment, kaduna electric power, kaduna electric prepaid, kaduna electric prepaid meter, kaduna electric quickteller, kaduna electric read meter, kaduna electric recruitment, kaduna electric toolkit, kaduna electric website, kaduna electric/webmail, kaduna electricity distribution plc, kaduna electricity recruitment, kaduna electricity recruitment portal, kaduna electricity workers protest, kaduna state electric, md kaduna electric, pay kaduna electric online, ussd code for kaduna electric, www.kaduna electric, ibadan electric, ibadan electricity distribution company, ibadan electric distribution company (ibedc) ibadan, ibadan electricity distribution company (ibedc), ibadan electricity distribution company customer care, ibadan electricity distribution company recruitment, ibadan electric distribution, ibadan electric distribution company, ibadan electric power distribution company, ibadan electric recruitment, ibadan electricity distribution company head office address, ibadan electricity distribution company jobs, ibadan electricity distribution company logo, ibadan electricity distribution company prepaid, ibadan electricity distribution company vacancy, abuja electric, abuja electricity distribution company, abuja electricity company, abuja electricity distribution, abuja electricity distribution company address, abuja electricity distribution company meter, abuja electricity distribution company online payment, abuja electricity distribution company recruitment, abuja electricity distribution company recruitment 2019, abuja electricity meter, abuja electricity portal, general electric abuja, general electric abuja office, general electric abuja office address, abuja electric address, abuja electric train, abuja electricity development company, abuja electricity distribution company logo, abuja electricity distribution company salary nairaland, abuja electricity distribution company tariff, abuja electricity meter registration, abuja electricity payment, abuja electricity recruitment, electric fence abuja, general electric abuja address, schneider electric abuja office, Keyword, aedc, usd to aed, aed to inr, aed to pkr, euro to aed, when did acdc start, aed to php, aed to gbp, aedc jobs, aedc tn, aedc tennessee, aedc wma, aedc fcu, aedc wind tunnel, sar to aed, aedc tullahoma, aedc white oak, aedc tunnel 9, aedc golf course, aedc wma map, aeedc dubai, aedc map, aedc address, aedc famcamp, aedc meter, aedc grants, aedc employment, aedc app, aedc careers, aedc website, how to buy aedc units online, aedc buy electricity, aedc news, aedc fcut union, aedc economic forecast luncheon, aedc online payment, aedc 2020, aedc 2019, aedc abuja, aedc abuja address, aedc abuja office, aedc application form, aedc bill, aedc board of directors, aedc buy power, aedc customer care, aedc customer service, aedc data, aedc data collection, aedc deer hunting, aedc domains, aedc electricity, aedc facebook, aedc form, aedc gwarinpa business office, aedc head office, aedc job portal, aedc job vacancy, aedc login, aedc logo, aedc meter application, aedc nigeria, aedc online, aedc online recharge, aedc payment, aedc phone number, aedc portal, aedc prepaid meter, aedc prepaid meter application, aedc prepaid meter form, aedc recharge, aedc recharge online, aedc recruitment, aedc registration, aedc salary structure, aedc saranac lake, aedc site, aedc tariff, aedc ussd code, aedc vacancy, aedc web portal, how much does aedc pay corpers, how to load aedc prepaid meter, how to pay aedc bill online, how to recharge aedc meter, how to recharge aedc meter online, how to recharge aedc prepaid meter online aedc internet, aedc internship, aedc interview questions, aedc j-5, aedc j5, aedc jabi, aedc jabi office, aedc job openings, aedc ka full form, aedc karu, aedc katampe, aedc keffi, aedc kenya, aedc latest news, aedc leave form, aedc leave management, aedc licence, aedc life camp, aedc lokogoma, aedc lokoja, aedc lugbe, aedc lyon 8, aedc managing director, aedc map payment, aedc md, aedc meter form, aedc meter number, aedc meter payment, aedc minna, aedc nairaland, aedc nas, aedc nas careers, aedc national report, aedc national report 2018, aedc new tariff, aedc news today, aedc number, aedc office asokoro, aedc office katampe, aedc office kubwa, aedc office lugbe, aedc office zone 4, aedc office zone 6, aedc offices in abuja, aedc official email, aedc online meter application, aedc opportunity zones, aedc pass and id, aedc past questions, aedc pay, aedc payment confirmation, aedc physical health and wellbeing, aedc power, aedc prepaid meter online application form, aedc qld, aedc queensland, aedc queensland report, aedc questionnaire, aedc unit, aedc unit price, aedc units online, how much is aedc prepaid meter, how to become aedc vendor, how to buy aedc online, how to check aedc meter number, how to recharge aedc prepaid meter, is aedc recruiting, is the aedc compulsory, letter to aedc, login to aedc, map for aedc, online payment for aedc, pay for aedc, paying for aedc online, ussd code for aedc, what are the aedc domains, what does aedc stand for, what is aedc data, phcn in nigeria, phcn lenox, phcn nigeria, phcn portal, phcn meter, phcn app, phcn online payment, buy phcn units online, how to buy phcn unit online, how to load phcn prepaid meter, how to load phcn prepaid meter online, how to pay phcn bill on quickteller, how to pay phcn prepaid bill online, how to recharge phcn prepaid meter, how to recharge phcn prepaid meter online, nepa to phcn, new name for phcn, pay for phcn online, pcn and tcn, pd(phcn)2cl2, phcn (ikeja district) lagos, phcn 16 months arrears, phcn abuja, phcn bill, phcn bill payment, phcn bill payment online, phcn career, phcn customer care number, phcn eko, phcn eko prepaid, phcn ex workers payment update, phcn forum, phcn headquarters abuja, phcn history, phcn ibadan, phcn ikeja, phcn ikeja electricity distribution company, phcn job, phcn job recruitment, phcn kaduna, phcn lagos, phcn latest news, phcn latest news 2019, phcn login, phcn logo, phcn meter number, phcn meter recharge, phcn new name, phcn news, phcn news today, phcn nigeria official website, phcn office lagos, phcn office near me, phcn official website, phcn online prepaid payment, phcn online recharge, phcn payment, phcn pins, phcn prepaid eko, phcn prepaid meter, phcn prepaid meter number, phcn quickteller, phcn recharge, phcn recharge online, pay your phcn bill online, paying for phcn bills online, payment for phcn, phcn 16 month, phcn 2019 recruitment, phcn 2020, phcn abuja contact, phcn abuja office address, phcn abuja online payment, phcn abule egba business unit, phcn account number, phcn act, phcn agent, phcn and bpe, phcn arizona, phcn benin, phcn bill calculation, phcn billing rate, phcn blackout, phcn board of directors, phcn borrow code, phcn branches in lagos, phcn buys generator, phcn call center, phcn chairman, phcn charges per kwh, phcn complaint centre, phcn contact, phcn cost per kwh, phcn customer card, phcn customer care number abuja, phcn customer care port harcourt, phcn disco, phcn disconnection, phcn distribution companies, phcn hotline, phcn ibadan electricity distribution company, phcn ikeja online payment, phcn ikoyi, phcn job vacancy, phcn jokes, phcn jos, phcn kaduna electricity distribution company, phcn kano, phcn laws, phcn lekki, phcn lekki phase 1 lekki, phcn là gì, phcn macomb, phcn map, phcn marysville, phcn meaning, phcn measures its electrical energy in, phcn meter application form, phcn moodle, phcn news 2020, phcn news 2019, phcn news update, phcn nigeria bill payment, phcn number, phcn office alausa, phcn office marina, phcn official site, phcn pension and gratuity, phcn phone number, phcn postpaid, phcn power generation, phcn prepaid meter application form, phcn prepaid recharge, phcn price per kilowatt, phcn privatisation update, phcn quickteller payment, phcn receipt, phcn recharge code, phcn reconnection fee, phcn recruitment portal 2019, phcn regulatory body, phcn rivers state, phcn rules and regulations, nigeria electric, nigeria electricity, nigeria electricity regulatory commission, nigeria electric regulatory commission, nigeria electrical outlet, nigeria electricity voltage, nigeria general electric, nigeria electric plug, electric fence nigeria, nigeria electricity hub, nigeria electricity news, nigeria electricity grid, schneider electric nigeria limited, nigeria electric power, latest news about nigeria electricity, latest news on nigeria electricity, nigeria electric adapter, nigeria electric company, nigeria electric current, nigeria electric manufacturers, nigeria electric meter, nigeria electric power generation, nigeria electric power policy, nigeria electric power sector reform act, nigeria electric railway, nigeria electric shock, nigeria electric socket, nigeria electric sockets, nigeria electric train, nigeria electric type, nigeria electric vehicles, nigeria electric voltage, nigeria electric wire, nigeria electricity grid map, nigeria electricity news today, nigeria electricity regulatory commission abuja, nigeria first electric car, electric nigeria website, schneider electric nigeria. ltd ikeja, zola electric nigeria address, electric ant nigeria, , , ikeja electric, ikeja electric job vacancies, ikeja electric job vacancy, ikeja electric live chat, ikeja electric career, how to pay ikeja electric bill online, ikeja electric payment, ikeja electric distribution company, ikeja electric prepaid meter application, how to load ikeja electric prepaid meter, ikeja electric customer care, how to activate ikeja electric prepaid meter, how to apply for ikeja electric prepaid meter, how to check ikeja electric prepaid balance, how to get ikeja electric prepaid meter, how to pay for ikeja electric bill online, how to recharge ikeja electric prepaid meter, ikeja electric account number, ikeja electric address, ikeja electric agents, ikeja electric app, ikeja electric bill payment, ikeja electric careers, ikeja electric contact number, ikeja electric crm, ikeja electric customer care number, ikeja electric distribution company customer care, ikeja electric distribution company recruitment, ikeja electric energy sales representative, ikeja electric job, ikeja electric jobs, ikeja electric kyc form, ikeja electric lagos, ikeja electric login, ikeja electric logo, ikeja electric map, ikeja electric meter asset provider, ikeja electric meter number, ikeja electric mission statement, ikeja electric news, ikeja electric nigeria, ikeja electric office address, ikeja electric official website, ikeja electric online payment, ikeja electric payment history, ikeja electric phone number, ikeja electric portal, ikeja electric prepaid meter, ikeja electric prepaid meter application form, ikeja electric prepaid meter number, ikeja electric prepaid meter registration, ikeja electric quickteller, ikeja electric recharge, ikeja electric recruitment, ikeja electric recruitment 2018, ikeja electric recruitment 2019, ikeja electric salary, ikeja electric salary nairaland, ikeja electric shomolu business unit lagos, ikeja electric tariff, ikeja electric vacancy, ikeja electric website, meter asset provider for ikeja electric, pay for ikeja electric bill online, pay ikeja electric bill online, quickteller ikeja electric prepaid, complaint letter to ikeja electric, customer care number for ikeja electric, download ikeja electric app, how much does ikeja electric pay, how to become ikeja electric agent, how to become ikeja electric dealer, how to pay ikeja electric online, how to recharge ikeja electric, ikeja electric account, ikeja electric account details, ikeja electric agent app, ikeja electric agent commission, ikeja electric alausa address, ikeja electric and magodo, ikeja electric and map, ikeja electric and sahara group, ikeja electric anthony, ikeja electric balance check, ikeja electric board"
      },
      {
        name: 'keywords',
        content:
          'ikeja electric board of directors, ikeja electric boss, ikeja electric business unit, ikeja electric business unit address, ikeja electric business units, ikeja electric call center agent, ikeja electric career website, ikeja electric ceo, ikeja electric charges, ikeja electric condition of service, ikeja electric core values, ikeja electric customer care working hours, ikeja electric customer complaint, ikeja electric customer registration, ikeja electric disco field office lagos, ikeja electric distribution company website, ikeja electric district, ikeja electric e payment, ikeja electric ebill, ikeja electric email, ikeja electric employment, ikeja electric energy sales representative salary, ikeja electric entry level salary, ikeja electric esr, ikeja electric esr final interview, ikeja electric esr interview, ikeja electric facebook, ikeja electric faq, ikeja electric final stage interview, ikeja electric financial statement, ikeja electric first stage interview, ikeja electric first stage interview nairaland, ikeja electric form, ikeja electric franchise, ikeja electric gbagada, ikeja electric glassdoor, ikeja electric gra, ikeja electric graduate trainee, ikeja electric head office, ikeja electric headquarters, ikeja electric help line, ikeja electric history, ikeja electric home, ikeja electric home page, ikeja electric hotline, ikeja electric hr, ikeja electric ikeja, ikeja electric ikeja business unit, ikeja electric ikorodu, ikeja electric ikorodu business unit ikorodu, ikeja electric ilupeju undertaking lagos, ikeja electric internal vacancy, ikeja electric interview, ikeja electric nairaland, ikeja electric nairaland 2020, ikeja electric nairaland 2019, ikeja electric near me, ikeja electric new tariff, ikeja electric number, ikeja electric offices, ikeja electric okota, ikeja electric olateju undertaking lagos, ikeja electric on twitter, ikeja electric online, ikeja electric online chat, ikeja electric opening hours, ikeja electric oregun, ikeja electric oshodi business unit, ikeja electric past questions, ikeja electric power outage, ikeja electric prepaid meter online payment, ikeja electric prepaid metre, ikeja electric rates, ikeja electric receipt, ikeja electric ussd code, ikeja electric vacancy 2018, ikeja electric vacancy 2019, ikeja electric vendor registration, ikeja electric vision, ikeja electric vision statement, ikeja electric vtu, ikeja electric whatsapp number, ikeja electric wikipedia, ikeja electric working hours, ikeja electric written test, ikeja electric young engineers program, ikeja electric young engineers program nairaland, ikeja electricity tariff, is ikeja electric on strike, letter to ikeja electric, live chat with ikeja electric, map for ikeja electric, online payment for ikeja electric, sample letter to ikeja electric, ussd code for ikeja electric, what does ikeja electric do, what is ikeja electric, who owns ikeja electric'
      }
    ]
  },
  components: {
    BankTransfer,
    UssdCode,
    Welcome,
    CreateAccount,
    CardResponse,
    SaveCard
  },
  created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
    if (localStorage.getItem('phone') !== null) {
      if (sessionStorage.getItem('status') === null) {
        // localStorage.setItem('userType', 2)
        if (
          localStorage.getItem('userType') != '2' ||
          localStorage.getItem('userType') != '1'
        ) {
          this.signedSession = true
        } else {
          this.signedSession = false
        }
      } else {
        this.signedSession = true
      }
    } else {
      this.signedSession = false
    }
  },
  mounted() {
    // initialize modal for the document
    this.initModal()
    $('.bills__side__wrapper').removeClass('left_out')
    if (localStorage.getItem('power') !== null) {
      this.fields.phone = localStorage.getItem('phone')
      $('#phone').val(this.fields.phone)
      var power = JSON.parse(localStorage.getItem('power'))
      if (power.message === 'Successful') {
        // if the transaction isn't empty for the user
        this.fields.amount = power.amount
        $('#amount').val(this.fields.amount)
        this.fields.receiver = power.receiver
        $('#meter_number').val(this.fields.receiver)
        this.fields.phone = power.phone
        $('#phone').val(this.fields.phone)
        this.fields.email = power.email
        $('#email').val(this.fields.email)
        this.fields.state = power.state
        $('#state').val(this.fields.state)
        this.fields.meterType = power.meter_type
        $('#meterType').val(this.fields.meterType)
        this.getDisco(this.fields.state, this.fields.meterType, 1)
      }
    } else {
      this.fields.phone = localStorage.getItem('phone')
      $('#phone').val(this.fields.phone)
    }
    if (
      localStorage.getItem('username') != '' &&
      localStorage.getItem('username') != null &&
      localStorage.getItem('username') != undefined
    ) {
      this.fields.username = localStorage.getItem('username')
    }
    $('select').formSelect()
    this.wallet_username = this.fields.phone
    M.updateTextFields()
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },
  data() {
    return {
      reveal: false,
      signedSession: false,
      // appkey: 'FLWPUBK-3585730a86447bf1c47e90b55284325b-X',
      mode: 2,
      appkey_test: 'pk_test_ad8895a4fe6b5f196b62a1a34a6c044addddbae1',
      appkey_live: 'pk_live_909a2c23b75ae6c5a442c9fe8ef4c634e7aac8d2',
      windows: {
        width: 0,
        height: 0
      },
      states: [
        'Abia',
        'Abuja FCT',
        // 'Adamawa',
        'Akwa Ibom',
        'Anambra',
        'Bauchi',
        'Bayelsa',
        'Benue',
        // 'Borno',
        'Cross River',
        // 'Delta',
        'Ebonyi',
        // 'Edo',
        'Ekiti',
        'Enugu',
        'Gombe',
        'Imo',
        'Jigawa',
        'Kaduna',
        'Kano',
        'Katsina',
        'Kebbi',
        'Kogi',
        'Kwara',
        'Lagos',
        'Nasarawa',
        'Niger',
        'Ogun',
        // 'Ondo',
        'Osun',
        'Oyo',
        'Plateau',
        'Rivers',
        'Sokoto',
        // 'Taraba',
        // 'Yobe',
        'Zamfara'
      ],
      fields: {
        source: 'iRecharge',
        state: '',
        meterType: '',
        category: 'iRecharge',
        username: '',
        platform: 'Website',
        d_uuid: '12345',
        d_platform: 'Website'
      },
      feedback: false,
      feedbackSuccess: false,
      feedbackloading: false,
      feedbackfield: {
        service: 'power'
      },
      proccedBtn: false,
      selectedDisco: '',
      lagosDisco: '',
      showSummary: false,
      modalInstance: {},
      mobileView: false,
      loading: false,
      payment_option: '',
      custName: '',
      custAddress: '',
      totalAmount: '',
      estUnits: '',
      transactionID: '',
      payment_ref: '',
      payment_option: '',
      voucher_code: '',
      payment_method: '',
      ussdoption: '',
      vending: false,
      vouching: false,
      successModal: false,
      token: '',
      units: '',
      orderInfo: '',
      service: 'electricity',
      generateDetails: {
        type: false,
        bank: 'GT Bank',
        account_name: 'IRECHARGE TECH-INNOVATIONS LTD',
        account_number: '0460540637'
      },
      discoName: '',
      wallet_password: '',
      wallet_username: '',
      walletProcess: false,
      updateAttempt: '',
      retrieveCard: {},
      reusable: false,
      coralpayCode: ''
    }
  },
  methods: {
    visibility() {
      this.reveal = !this.reveal
    },
    doCopy: function() {
      let container = this.$refs.container
      this.$copyText(this.token, container)
      $('.copyBtn').text('Copied')
      setTimeout(() => {
        $('.copyBtn').text('Click to copy')
      }, 3000)
    },
    proceedWithNewCard() {
      this.modalInstance[7].close()
      this.PayStack()
    },
    retrieveCardDetails() {
      this.vending = true
      let obj = {
        username: this.fields.username
      }
      obj.passcode = this.hash(obj.username.toString())
      this.axios
        .post('https://irecharge.com.ng/api/card/retrieve.php', obj)
        .then(response => {
          if (response.data.status == '0') {
            this.retrieveCard = response.data
            this.modalInstance[7].open()
          } else {
            this.PayStack()
          }
          if (response.data.message == 'Unauthorized Access') {
            $('.toast').hide()
            M.toast({
              html: 'We could not verify, please try again.',
              classes: 'error'
            })
          }
          this.vending = false
        })
        .catch(error => {
          $('.toast').hide()
          M.toast({
            html: 'Could not send request, check network.',
            classes: 'error'
          })
          this.vending = true
        })
    },
    saveCard(option) {
      this.reusable = false
      this.modalInstance[8].close()
      let obj = {
        username: this.fields.username,
        response: option
      }
      obj.passcode = this.hash(obj.username.toString())
      this.axios
        .post('https://irecharge.com.ng/api/card/save.php', obj)
        .then(response => {
          if (response.data.status == '0') {
            M.toast({ html: response.data.message, classes: 'success' })
          } else {
            M.toast({ html: response.data.message, classes: 'success' })
          }
          if (response.data.message == 'Unauthorized Access') {
            $('.toast').hide()
            M.toast({
              html: 'We could not verify, please try again.',
              classes: 'error'
            })
          }
        })
        .catch(error => {
          $('.toast').hide()
          M.toast({
            html: 'Could not send request, check network.',
            classes: 'error'
          })
        })
    },
    chargeCard(password) {
      // verify the user password
      this.vending = true
      // set form data
      var bodyFormData = new FormData()
      bodyFormData.set('relocate', 'login')
      bodyFormData.set('action', 'login')
      bodyFormData.set('inputEmail', this.wallet_username)
      bodyFormData.set('inputPassword', password)
      this.axios
        .post('control1.php', bodyFormData)
        .then(response => {
          if (response.data.status == 1) {
            // charge the card and vend
            this.modalInstance[7].close()
            $('.toast').hide()
            M.toast({
              html: 'Verification Successful, Please wait, while we charge the card...',
              classes: 'success'
            })
            this.vending = true
            let obj = {
              username: localStorage.getItem('username') ? localStorage.getItem('username') : this.fields.username,
              amount: this.fields.totalAmount,
              last4: this.retrieveCard.last4
            }
            obj.passcode = this.hash(obj.username.toString())
            this.axios
              .post('https://irecharge.com.ng/api/card/charge.php', obj)
              .then(response => {
                if (response.data.status == '0') {
                  this.payment_ref = response.data.payment_ref
                  M.toast({
                    html: 'Card successfully charged, vending in progress',
                    classes: 'success'
                  })
                  this.vendPower()
                } else {
                  M.toast({
                    html:
                      'We could not charge the selected card, redirecting to paystack in 3sec...',
                    classes: 'info'
                  })
                  setTimeout(() => {
                    $('.toast').hide()
                    this.PayStack()
                  }, 3000)
                }
                if (response.data.message == 'Unauthorized Access') {
                  $('.toast').hide()
                  M.toast({
                    html: 'We could not verify, please try again.',
                    classes: 'error'
                  })
                }
                this.vending = false
              })
              .catch(error => {
                $('.toast').hide()
                M.toast({
                  html: 'Could not send request, check network.',
                  classes: 'error'
                })
                this.vending = false
              })
          } else {
            this.vending = false
            $('.toast').hide()
            M.toast({ html: response.data.message, classes: 'info' })
          }
        })
        .catch(error => {
          $('.toast').hide()
          M.toast({
            html: 'Could not send request, check network.',
            classes: 'error'
          })
          this.vending = false
        })
    },
    selectedView(option) {
      this.$emit('modal-option', option)
    },
    verifyWallet() {
      if (this.ValidateWalletData()) {
        this.reveal = false
        this.walletProcess = true
        // set form data
        var bodyFormData = new FormData()
        bodyFormData.set('relocate', 'login')
        bodyFormData.set('action', 'login')
        bodyFormData.set('inputEmail', this.wallet_username)
        bodyFormData.set('inputPassword', this.wallet_password)
        this.axios
          .post('control1.php', bodyFormData)
          .then(response => {
            if (response.data.status == 1) {
              $('.toast').hide()
              M.toast({
                html: 'Verification Successful, Please wait while we vend...',
                classes: 'success'
              })
              let obj = {
                transaction_id: this.transactionID,
                payment_ref: this.transactionID,
                payment_method: this.payment_method,
                voucher_code: this.voucher_code,
                user_numid: response.data.userid
              }
              obj.passcode = this.hash(this.transactionID)
              this.axios
                .post('https://irecharge.com.ng/api/power/vend.php', obj)
                .then(response => {
                  if (response.data.status == '0') {
                    this.successModal = true
                    this.revert()
                    // this.emptyFormInputs()
                    this.payment_ref = response.data.payment_ref
                    this.orderInfo = response.data.title
                    this.token = response.data.token
                    this.units = response.data.units
                    this.modalInstance[4].open() // transaction succeful modal
                    this.modalInstance[5].close() // Close wallet modal
                    this.disableFormInputs(false)
                    this.updateStorage(
                      this.fields.amount,
                      this.selectedDisco,
                      this.fields.state,
                      this.fields.meterType,
                      this.fields.phone,
                      this.fields.receiver,
                      this.fields.email
                    )
                    this.walletProcess = false
                    $('.toast').hide()
                    M.toast({
                      html: 'Your token has arrived.',
                      classes: 'success'
                    })
                  } else {
                    this.walletProcess = false
                    this.proccedBtn = true
                    $('.toast').hide()
                    M.toast({ html: response.data.message, classes: 'error' })
                  }
                })
                .catch(error => {
                  $('.toast').hide()
                  M.toast({
                    html: 'Could not send request, check network.',
                    classes: 'error'
                  })
                  this.vouching = false
                })
            } else {
              this.walletProcess = false
              $('.toast').hide()
              M.toast({ html: response.data.message, classes: 'info' })
            }
          })
          .catch(error => {
            $('.toast').hide()
            M.toast({
              html: 'Could not send request, check network.',
              classes: 'error'
            })
            this.walletProcess = false
          })
      }
    },
    ValidateWalletData() {
      if (this.wallet_username != '') {
        if (this.wallet_password != '') {
          return true
        } else {
          $('.toast').hide()
          M.toast({ html: 'Password is required', classes: 'info' })
        }
      } else {
        $('.toast').hide()
        M.toast({ html: 'Email/Phone number is required', classes: 'info' })
      }
    },
    createAccount(option) {
      this.$emit('modal-option', option)
      document.getElementById('myNav').style.width = '100%'
      this.modalInstance[4].close()
    },
    formatNumber(num) {
      var result = num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
      $('#amount').val(result)
    },
    whatsApp() {
      var message =
        "Hello! Here's your token for " +
        this.discoName +
        ' power transaction of N' +
        this.totalAmount +
        ' to ' +
        this.fields.receiver +
        ': ' +
        this.token +
        '. Thank you for using iRecharge https://irecharge.ng'
      window.open(
        'https://api.whatsapp.com/send?phone=&text=' + encodeURI(message),
        '_blank'
      )
      // window.open('https://api.whatsapp.com/send?phone=&text=Hello!%20I%27ve%20just%20made%20some%20transactions%20seamlessly%20right%20now.%20Try%20it%20out%20here,%20you%27ll%20enjoy%20their%20service%20https://irecharge.ng', '_blank');
    },
    getDisco(state, meterType, lagosDisco) {
      state = state.toLowerCase()
      let disco = ''
      if (
        state == 'abuja fct' ||
        state == 'nasarawa' ||
        state == 'kogi' ||
        state == 'niger' ||
        state == 'fct'
      ) {
        if (meterType === 2) {
          disco = 'AEDC_Postpaid'
        } else {
          disco = 'AEDC'
        }
      }
      if (
        state == 'kaduna' ||
        state == 'sokoto' ||
        state == 'kebbi' ||
        state == 'zamfara'
      ) {
        if (meterType === 2) {
          disco = 'Kaduna_Electricity_Disco_Postpaid'
        } else {
          disco = 'Kaduna_Electricity_Disco'
        }
      }
      if (
        state == 'plateau' ||
        state == 'bauchi' ||
        state == 'benue' ||
        state == 'gombe'
      ) {
        if (meterType === 2) {
          disco = 'Jos_Disco_Postpaid'
        } else {
          disco = 'Jos_Disco'
        }
      }
      if (state == 'kano' || state == 'jigawa' || state == 'katsina') {
        disco = 'Kano_Electricity_Disco'
      }
      if (
        state == 'oyo' ||
        state == 'ibadan' ||
        state == 'osun' ||
        state == 'ogun' ||
        state == 'kwara'
      ) {
        disco = 'Ibadan_Disco_Prepaid'
      }
      if (
        state == 'rivers' ||
        state == 'cross river' ||
        state == 'akwa ibom' ||
        state == 'bayelsa'
      ) {
        if (meterType === 2) {
          disco = 'PH_Disco'
        } else {
          disco = 'PhED_Electricity'
        }
      }
      if (
        state == 'delta' ||
        state == 'edo' ||
        state == 'ekiti' ||
        state == 'ondo'
      ) {
        disco = 'Benue_Disco'
      }
      if (
        state == 'enugu' ||
        state == 'abia' ||
        state == 'imo' ||
        state == 'anambra' ||
        state == 'ebonyi'
      ) {
        disco = 'EEDC'
      }
      if (state == 'lagos') {
        if (lagosDisco === 1) {
          if (meterType === 2) {
            disco = 'Eko_Postpaid'
          } else {
            disco = 'Eko_Prepaid'
          }
        }
        if (lagosDisco === 2) {
          if (meterType === 2) {
            disco = 'Ikeja_Electric_Bill_Payment'
          } else {
            disco = 'Ikeja_Token_Purchase'
          }
        }
      }
      this.selectedDisco = disco
      this.discoName = disco.replace(/[^a-zA-Z ]/g, ' ')
    },
    handleResize() {
      this.windows.width = window.innerWidth
      this.windows.height = window.innerHeight
    },
    disableFormInputs(option) {
      const formInput = document.querySelectorAll('#form input')
      const formSelect = document.querySelectorAll('#form select')
      formInput.forEach(function(item) {
        item.disabled = option
      })
      formSelect.forEach(function(item) {
        item.disabled = option
      })
    },
    setParameters() {
      this.fields.disco = this.selectedDisco // sets the disco of the customer
      this.fields.d_model = window.navigator.vendor
      this.fields.d_name = window.navigator.vendor
    },
    payOption(option) {
      if (option == '') {
        $('.toast').hide()
        M.toast({ html: 'Kindly select payment option', classes: 'info' })
      } else {
        if (option == '1') {
          // Card payment option
          this.payment_method = 'Card'
          if (this.fields.username != '') {
            // check if card details exist
            this.retrieveCardDetails()
          } else {
            this.PayStack()
          }
        }
        if (option == '2') {
          // Voucher payment option
          this.payment_method = 'Voucher'
          this.modalInstance[1].open()
        }
        if (option == '3') {
          // USSD code payment option
          this.service = 'electricity'
          this.generateUSSDCode()
        }
        if (option == '4') {
          // Bank transfer payment option
          this.service = 'electricity'
          this.generateBank()
        }
        if (option == '5') {
          // Wallet payment option
          this.payment_method = 'Wallet'
          this.modalInstance[5].open()
        }
        
        try{ 
        __adroll.track("pageView", {"segment_name":"cbb9972f"}) 
        } catch(err) {}

      }


    },
    generateUSSDCode() {
      this.vending = true
      let obj = {}
      obj.transaction_id = this.transactionID
      obj.service = this.service
      obj.passcode = this.hash(obj.transaction_id)
      this.axios
        .post('https://irecharge.com.ng/api/coralpay/generate.php', obj)
        .then(response => {
          if (response.data.status == '0') {
            this.coralpayCode = response.data.code
            this.modalInstance[2].open()
          } else {
            $('.toast').hide()
            M.toast({
              html: 'Error generating code, click "PAY" again',
              classes: 'error'
            })
          }
          if (response.data.message == 'Unauthorized Access') {
            this.disableFormInputs(false)
            $('.toast').hide()
            M.toast({
              html: 'We could not verify, please try again.',
              classes: 'error'
            })
          }
          this.vending = false
        })
        .catch(error => {
          $('.toast').hide()
          M.toast({
            html: 'Could not send request, check network.',
            classes: 'error'
          })
          this.vending = false
        })
    },
    generateBank() {
      this.vending = true
      let obj = {}
      obj.transaction_id = this.transactionID
      obj.service = this.service
      obj.passcode = this.hash(this.transactionID)
      this.axios
        .post('https://irecharge.com.ng/api/teamapt/generate.php', obj)
        .then(response => {
          if (response.data.status == '0') {
            this.generateDetails.account_name = response.data.account_name
            this.generateDetails.account_number = response.data.account_number
            this.generateDetails.bank = response.data.bank
            this.generateDetails.type = true
            this.modalInstance[3].open()
          } else {
            this.generateDetails.account_name = response.data.account_name
            this.generateDetails.account_number = response.data.account_number
            this.generateDetails.bank = response.data.bank
            this.modalInstance[3].open()
          }
          if (response.data.message == 'Unauthorized Access') {
            this.disableFormInputs(false)
            $('.toast').hide()
            M.toast({
              html: 'We could not verify, please try again.',
              classes: 'error'
            })
          }
          this.vending = false
        })
        .catch(error => {
          $('.toast').hide()
          M.toast({
            html: 'Could not send request, check network.',
            classes: 'error'
          })
          this.vending = false
        })
    },
    sendFeedback() {
      this.feedbackloading = true
      let obj = {
        recommend: '',
        satisfaction: '',
        service: this.feedbackfield.service,
        transaction_id: this.transactionID,
        comment: this.feedbackfield.comment
      }
      if (this.feedbackfield.recommend) {
        obj.recommend = 'yes'
      } else {
        obj.recommend = 'no'
      }
      if (this.feedbackfield.satisfaction) {
        obj.satisfaction = 'yes'
      } else {
        obj.satisfaction = 'no'
      }
      obj.passcode = this.hash(this.transactionID)
      this.axios
        .post('https://irecharge.com.ng/api/feedback/submit.php', obj)
        .then(response => {
          if (response.data.status == '0') {
            this.feedbackloading = false
            this.feedback = false
            this.feedbackSuccess = true
            $('.toast').hide()
            M.toast({ html: 'Feedback received', classes: 'success' })
          } else {
            this.feedbackloading = false
            $('.toast').hide()
            M.toast({ html: response.data.message, classes: 'info' })
          }
        })
        .catch(error => {
          $('.toast').hide()
          M.toast({
            html: 'Could not send request, check network.',
            classes: 'error'
          })
          this.vouching = false
        })
    },
    verifyVoucher() {
      if (this.payment_method == 'Voucher') {
        if (this.voucher_code == '') {
          $('.toast').hide()
          M.toast({ html: 'Kindly enter your voucher code', classes: 'info' })
        } else {
          this.vouching = true
          let obj = {
            transaction_id: this.transactionID,
            payment_ref: this.transactionID,
            payment_method: this.payment_method,
            voucher_code: this.voucher_code
          }
          obj.passcode = this.hash(this.transactionID)
          this.axios
            .post('https://irecharge.com.ng/api/power/vend.php', obj)
            .then(response => {
              if (response.data.status == '0') {
                this.successModal = true
                this.revert()
                // this.emptyFormInputs()
                this.payment_ref = response.data.payment_ref
                this.orderInfo = response.data.title
                this.token = response.data.token
                this.units = response.data.units
                this.modalInstance[4].open() // transaction succeful modal
                this.modalInstance[1].close()
                this.disableFormInputs(false)
                this.updateStorage(
                  this.fields.amount,
                  this.selectedDisco,
                  this.fields.state,
                  this.fields.meterType,
                  this.fields.phone,
                  this.fields.receiver,
                  this.fields.email
                )
                this.vouching = false
                $('.toast').hide()
                M.toast({ html: 'Your token has arrived.', classes: 'success' })
              } else {
                this.vouching = false
                this.proccedBtn = true
                $('.toast').hide()
                M.toast({ html: response.data.message, classes: 'error' })
              }
            })
            .catch(error => {
              $('.toast').hide()
              M.toast({
                html: 'Could not send request, check network.',
                classes: 'error'
              })
              this.vouching = false
            })
        }
      }
    },
    getMeterInfo() {
      if (this.ValidateData()) {
        // Validate information on form
        this.loading = true
        localStorage.setItem(
          'email',
          JSON.stringify(this.fields.email != '' ? this.fields.email : null)
        )
        this.setParameters() // set the device name and model
        this.fields.passcode = this.hash(this.fields.receiver.toString())
        this.axios
          .post('https://irecharge.com.ng/api/power/verify.php', this.fields)
          .then(response => {
            if (response.data.status == '0') {
              this.transactionID = response.data.transaction_id
              // sets the customer information
              this.totalAmount = response.data.total_amount
              this.custName = response.data.cust_name
              this.custAddress = response.data.cust_address
              this.estUnits = response.data.estunits
              this.proccedBtn = true
              // Show modal with Customer Information
              this.modalInstance[0].open()
              $('.toast').hide()
              M.toast({
                html: 'Kindly verify meter information',
                classes: 'success'
              })
              if (this.windows.width <= 900) {
                const formInput = document.querySelector('#leftContainment')
                formInput.style.display = 'none'
              }
              if (this.windows.width >= 1200) {
                this.mobileView = true
              }
            } else {
              this.disableFormInputs(false)
              $('.toast').hide()
              M.toast({ html: response.data.message, classes: 'info' })
            }
            if (response.data.message == 'Unauthorized Access') {
              this.disableFormInputs(false)
              $('.toast').hide()
              M.toast({
                html: 'We could not verify, please try again.',
                classes: 'error'
              })
            }
            this.loading = false
            this.disableFormInputs(false)
          })
          .catch(error => {
            $('.toast').hide()
            M.toast({
              html: 'Could not send request, check network.',
              classes: 'error'
            })
            this.loading = false
            this.disableFormInputs(false)
          })
      }
    },
    verifiedMeter() {
      // proceeds to summary if agreed
      if (this.windows.width <= 900) {
        const formInput = document.querySelector('#leftContainment')
        formInput.style.display = 'none'
      }
      if (this.windows.width >= 1200) {
        this.mobileView = true
      }
      $('.toast').hide()
      this.proccedBtn = true
      this.showSummary = true
      // display the create account modal
      if (localStorage.getItem('user') == 'false') {
        if (localStorage.getItem('attempts') <= '1') {
          this.updateAttempt = localStorage.getItem('attempts')
          this.modalInstance[6].open()
          localStorage.setItem('attempts', 0)
        }
      }
    },
    vendPower() {
      this.vending = true
      let obj = {
        transaction_id: this.transactionID,
        payment_ref: this.payment_ref,
        payment_method: this.payment_method,
        voucher_code: ''
      }
      obj.passcode = this.hash(this.transactionID)
      this.axios
        .post('https://irecharge.com.ng/api/power/vend.php', obj)
        .then(response => {
          if (response.data.status == '0') {
            this.payment_ref = response.data.payment_ref
            this.orderInfo = response.data.title
            this.token = response.data.token
            this.units = response.data.units
            this.reusable = response.data.reusable
            this.modalInstance[4].open()
            if (this.reusable == true) {
              this.modalInstance[8].open()
            }
            $('.toast').hide()
            M.toast({ html: 'Your token just arrived.', classes: 'success' })
            this.successModal = true
            this.showSummary = false
            this.proccedBtn = false
            this.emptyFormInputs()
            this.disableFormInputs(false)
            this.revert()
            this.updateStorage(
              this.fields.amount,
              this.selectedDisco,
              this.fields.state,
              this.fields.meterType,
              this.fields.phone,
              this.fields.receiver,
              this.fields.email
            )
            this.vending = false
          } else {
            this.successModal = false
            this.vending = false
            this.showSummary = false
            this.proccedBtn = false
            this.disableFormInputs(true)
            this.modalInstance[4].open()
            $('.toast').hide()
            M.toast({ html: response.data.message, classes: 'error' })
          }
        })
        .catch(error => {
          $('.toast').hide()
          M.toast({
            html: 'Could not send request, check network.',
            classes: 'error'
          })
          this.loading = false
        })
    },
    updateStorage(amount, disco, state, meterType, phone, receiver, email) {
      var obj = {
        amount: amount,
        disco: 0,
        disco_name: disco,
        email: email,
        message: 'Successful',
        meter_type: meterType,
        phone: phone,
        receiver: receiver,
        service: 'power',
        state: state
      }
      localStorage.setItem('power', JSON.stringify(obj))
    },
    PayStack() {
      this.vending = true
      const that = this
      var value = this.totalAmount * 100
      let appkey = this.appkey_test
      if (this.mode == 2) {
        appkey = this.appkey_live
      }
      var handler = PaystackPop.setup({
        key: appkey,
        email:
          this.fields.email == undefined || this.fields.email == ''
            ? 'website@istrategytech.com'
            : this.fields.email,
        amount: value,
        metadata: {
          custom_fields: [
            {
              customer_phone: this.fields.phone,
              customer_email:
                this.fields.email == undefined || this.fields.email == ''
                  ? 'website@istrategytech.com'
                  : this.fields.email,
              txRef: this.transactionID
            }
          ]
        },
        callback: function(response) {
          let status = response.status,
            message = response.message
          if (status == 'success' && message == 'Approved') {
            // vend airtime now
            that.payment_ref = response.reference
            that.vendPower()
          } else {
            // payment could not be completed
            that.successModal = false
            that.showSummary = false
            that.proccedBtn = false
            that.disableFormInputs(true)
            that.modalInstance[4].open()
            that.vending = false
          }
        },
        onClose: function() {
          // that.emptyFormInputs()
          that.disableFormInputs(false)
          that.vending = false
        }
      })
      handler.openIframe()
    },
    revert() {
      const formInput = document.querySelector('#leftContainment')
      formInput.style.display = 'block'
      this.proccedBtn = false
      this.showSummary = false
      this.disableFormInputs(false)
    },
    ValidateData() {
      if (this.fields.state) {
        if (this.fields.meterType) {
          if (this.fields.receiver) {
            if (this.fields.amount) {
              if (this.fields.phone) {
                if (this.fields.phone.toString().length === 11) {
                  this.disableFormInputs(true)
                  return true
                } else {
                  $('.toast').hide()
                  M.toast({
                    html: 'Phone number must be 11 characters',
                    classes: 'info'
                  })
                }
              } else {
                $('.toast').hide()
                M.toast({ html: 'Phone number is required!', classes: 'info' })
              }
            } else {
              $('.toast').hide()
              M.toast({ html: 'Amount field is required!', classes: 'info' })
            }
          } else {
            $('.toast').hide()
            M.toast({ html: 'Please enter a Meter number!', classes: 'info' })
          }
        } else {
          $('.toast').hide()
          M.toast({ html: 'Please select a Meter Type!', classes: 'info' })
        }
      } else {
        $('.toast').hide()
        M.toast({ html: 'Please select a state!', classes: 'info' })
      }
    },
    initModal() {
      // initialize modal for the document
      const option = {
        dismissible: false,
        endingTop: '6%',
        preventScrolling: true
      }
      var elems = document.querySelectorAll('.modal.services')
      var instances = M.Modal.init(elems, option)
      this.modalInstance = instances
    },
    emptyFormInputs() {
      const formInput = document.querySelectorAll('#form input')
      const formSelect = document.querySelectorAll('#form select')
      formInput.forEach(function(item) {
        item.value = ''
      })
      formSelect.forEach(function(item) {
        item.value = 'Select option'
      })
    },
    ussdComplete() {
      this.disableFormInputs(false)
      this.revert()
      this.updateStorage(
        this.fields.amount,
        this.selectedDisco,
        this.fields.state,
        this.fields.meterType,
        this.fields.phone,
        this.fields.receiver,
        this.fields.email
      )
      ;(this.vending = false), (this.showSummary = false)
      this.proccedBtn = false
      // this.emptyFormInputs()
    },
    hash(ref) {
      let passcode = '123NDSx'
      let encrypted = CryptoJS.HmacSHA512(ref, passcode)
      return encrypted.toString()
    }
  }
}
</script>

<style>
strong {
  font-weight: 600;
}
span.token {
  font-size: 22px;
}
</style>
